/** The longest Move Back reason the API stores. */
export const REVERT_REASON_MAX_LENGTH = 2000;
//# sourceMappingURL=revert-reason-max-length.js.map